import { KSK1070_R01LotDto } from 'src/containers/mes/KSK/KSK1070_R01/Dto_KSK1070_R01';
import { WmsTransportLotDto } from 'src/dtos/wmsTransport/wmsTransportDto';

export const getPurchaseLotNoKey = (lot: Pick<KSK1070_R01LotDto, 'purchaseLotNo'>): string =>
	(lot.purchaseLotNo ?? '').trim();

/** 포장량 기준 LOT별 입고량 배열 (마지막 요소는 나머지) */
export function computePackQtyLotAmounts(totalQty: number, packQty: number): number[] {
	const total = Number(totalQty) || 0;
	const pack = Number(packQty) || 0;

	if (total <= 0) {
		return [];
	}

	if (pack <= 0) {
		return [total];
	}

	const fullCount = Math.floor(total / pack);
	const remainder = total % pack;
	const amounts: number[] = [];

	for (let i = 0; i < fullCount; i++) {
		amounts.push(pack);
	}

	if (remainder > 0) {
		amounts.push(remainder);
	}

	return amounts;
}

/** 주문잔량을 포장량 단위로 분할한 LOT 행 목록 생성 */
export function buildLotsByPackQty(
	totalQty: number,
	packQty: number,
	baseLot: KSK1070_R01LotDto,
	startValueIndex = 1,
): KSK1070_R01LotDto[] {
	const amounts = computePackQtyLotAmounts(totalQty, packQty);

	return amounts.map((lotQty, index) => ({
		...baseLot,
		valueIndex: startValueIndex + index,
		orderIndex: startValueIndex + index,
		orderIndexSeq: 0,
		lotQty,
		inserted: true,
		isModified: false,
	}));
}

const reindexLots = (lots: KSK1070_R01LotDto[], startValueIndex = 1): KSK1070_R01LotDto[] =>
	lots.map((lot, index) => ({
		...lot,
		valueIndex: startValueIndex + index,
		orderIndex: startValueIndex + index,
		orderIndexSeq: 0,
	}));

/**
 * 이번 구매 Lot의 수량(x)만 포장량으로 나눠 행을 만들고, 기존 Lot 행은 그대로 둔다.
 * 첫 적용이면 기존 미리보기 행은 버리고 이번 구매 Lot만 생성한다.
 */
export function buildLotsByPurchaseLotAndPackQty(params: {
	existingLots: KSK1070_R01LotDto[];
	totalQty: number;
	packQty: number;
	purchaseLotNo: string;
	baseLot: KSK1070_R01LotDto;
	isFirstApply?: boolean;
}): { lots: KSK1070_R01LotDto[]; error?: string } {
	const purchaseLotNo = params.purchaseLotNo.trim();
	const keptLots = params.isFirstApply ? [] : params.existingLots;
	const existingPurchaseLotNos = new Set(
		keptLots.map(getPurchaseLotNoKey).filter((lotNo) => lotNo !== ''),
	);

	if (purchaseLotNo && existingPurchaseLotNos.has(purchaseLotNo)) {
		return {
			lots: [],
			error: `이미 적용된 구매 Lot입니다. (${purchaseLotNo})`,
		};
	}

	const newLots = buildLotsByPackQty(
		params.totalQty,
		params.packQty,
		{
			...params.baseLot,
			purchaseLotNo,
		},
		keptLots.length + 1,
	);

	return { lots: reindexLots([...keptLots, ...newLots]) };
}
